import styled from "@emotion/styled";
import { Badge, BadgeProps } from "@mui/material";
import UserAvatar from "components/profile/user-avatar";
import EditIcon from '@mui/icons-material/Edit';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }: any) => ({
	'& .MuiBadge-badge': {
		right: '-15%',
		top: '85%',
		transform: 'translate(-50%, -50%)',
		border: `2px solid white`,
		padding: 0,
		backgroundColor: theme.palette.primary.main,
		width: '36px',
		height: '36px',
		borderRadius: '50%'
	},
}));

const StyledEditIcon = styled(EditIcon)`
    width: 24px;
    height: 24px;
	color: white;
`

interface Props {
	src?: string;
	alt?: string;
	size?: number;
	onUpload: (file: File) => unknown;
}

const EditUserAvatarButton = ({ src, alt, size = 150, onUpload }: Props) => {
	return (
		<>
			<label htmlFor="user-avatar-input" className="relative">
				<StyledBadge badgeContent={<StyledEditIcon />} className="cursor-pointer">
					<UserAvatar src={src} alt={alt} size={size} />
				</StyledBadge>
			</label>
			<input
				id="user-avatar-input"
				type="file"
				className="hidden"
				name="avatar"
				accept='image/png, image/jpeg'
				onChange={(event) => {
					if (event.currentTarget.files?.[0]) {
						const file = event.currentTarget.files?.[0];
						onUpload(file);
					}
				}}
			/>
		</>

	);
};

export default EditUserAvatarButton;
